import { PlayerType, ThemeType } from "./types";

export const playerColor = (
  player: PlayerType,
  judge: string,
  theme: ThemeType
) => {
  return player.Name === judge
    ? theme.ReminderColor
    : player.Submitted
    ? theme.TextColor
    : theme.ButtonColor;
};
